import { getSignedUrlPromise, S3Context as S3Context_1 } from "../Common/AwsCommon.js";
import { update as update_1, init as init_1 } from "./StentPlanning/StentPlanningState.js";
import { OutboundMsg, ModelVisualization, LocalMsg, VisualizationSubcomponentModel as VisualizationSubcomponentModel_2 } from "./VisualizationTypes.js";
import { Cmd_ofEffect, Cmd_OfPromise_either, Cmd_none, Cmd_batch, Cmd_map } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { update as update_2, wrapInboundMsg, wrapLocalMsg } from "../Common/InboundOutbound.js";
import { update, init as init_2 } from "./VisualizationTemp/VisualizationTempState.js";
import { LoadingStatus as LoadingStatus_5 } from "./Common/CommonTypes.js";
import { forAll, FSharpMap__get_IsEmpty, add, empty } from "../fable_modules/fable-library-js.4.19.3/Map.js";
import { equals, comparePrimitives } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { append as append_1, ofArray, map, empty as empty_1, singleton } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.4.19.3/AsyncBuilder.js";
import { parallel, awaitPromise } from "../fable_modules/fable-library-js.4.19.3/Async.js";
import { fetch$ } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Shared_delayedMsg, Shared_UiDataFile } from "./VisualizationShared.js";
import { InboundMsg } from "./VisualizationTemp/VisualizationTempTypes.js";
import { InboundMsg as InboundMsg_1 } from "./StentPlanning/StentPlanningTypes.js";
import { some } from "../fable_modules/fable-library-js.4.19.3/Option.js";
import { Toast_warningToastWithTimeout, Toast_errorToast } from "../Common/General.js";
import { toConsole, printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { extractData } from "./Meshes/MeshExtraction.js";
import { singleton as singleton_2, append, delay, toList } from "../fable_modules/fable-library-js.4.19.3/Seq.js";

export function setupS3Context(context) {
    return new S3Context_1(context.S3Config, context.S3Client, context.S3Expiry, context.S3Config.PermanentBucket);
}

export function init(s3Context, studies, selectedPatient, selectedStudy, visualizationDataFile, institutionDesignation, maybeCurrentUser, isStentPlanning) {
    const s3Context_1 = setupS3Context(s3Context);
    let patternInput;
    if (isStentPlanning) {
        const tupledArg = init_1(s3Context_1, studies, selectedPatient, selectedStudy, institutionDesignation, maybeCurrentUser);
        patternInput = [new VisualizationSubcomponentModel_2(1, [tupledArg[0]]), Cmd_map((arg) => (new LocalMsg(10, [wrapLocalMsg(arg)])), tupledArg[1])];
    }
    else {
        const tupledArg_1 = init_2(s3Context_1, studies, selectedPatient, selectedStudy, institutionDesignation, maybeCurrentUser);
        patternInput = [new VisualizationSubcomponentModel_2(0, [tupledArg_1[0]]), Cmd_map((arg_1) => (new LocalMsg(9, [wrapLocalMsg(arg_1)])), tupledArg_1[1])];
    }
    return [new ModelVisualization(maybeCurrentUser, institutionDesignation, visualizationDataFile, new LoadingStatus_5(0, []), undefined, s3Context_1, selectedStudy, selectedPatient.id, 0, undefined, patternInput[0], empty({
        Compare: comparePrimitives,
    }), undefined), Cmd_batch(singleton(patternInput[1]))];
}

export function fetchDataAsArrayBuffer(url) {
    return singleton_1.Delay(() => singleton_1.Bind(awaitPromise(fetch$(url, empty_1())), (_arg) => {
        const response = _arg;
        return singleton_1.Bind(awaitPromise(response.arrayBuffer()), (_arg_1) => singleton_1.Return(new Shared_UiDataFile(_arg_1, (response.headers).get('ETag'))));
    }));
}

export function fetchManyAsArrayBuffer(urls) {
    return parallel(map(fetchDataAsArrayBuffer, urls));
}

export function updateInbound(_arg, msg, model) {
    let msg_4, msg_7, msg_10;
    switch (msg.tag) {
        case 1:
            return [model, singleton((dispatch) => {
                dispatch(new LocalMsg(1, []));
            }), Cmd_none()];
        case 2: {
            const study = msg.fields[0];
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, study, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_batch(ofArray([(msg_4 = (new LocalMsg(9, [wrapInboundMsg(new InboundMsg(2, [study]))])), singleton((dispatch_1) => {
                dispatch_1(msg_4);
            })), (msg_7 = (new LocalMsg(10, [wrapInboundMsg(new InboundMsg_1(2, [study]))])), singleton((dispatch_2) => {
                dispatch_2(msg_7);
            }))])), Cmd_none()];
        }
        case 3:
            return [model, (msg_10 = (new LocalMsg(10, [wrapInboundMsg(new InboundMsg_1(3, []))])), singleton((dispatch_3) => {
                dispatch_3(msg_10);
            })), Cmd_none()];
        default:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, setupS3Context(msg.fields[1]), model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_none(), Cmd_none()];
    }
}

export function updateLocal(token, msg, model) {
    let arg, list_2;
    let matchResult, ex, url_1, arrayBuffer, arrayBuffer_1, extractedData, ex_1, extractedData_1, imageData, msg_13, reportData, svm, status, msg_22, reportData_1, svm_1, isReady, viewportId, timeoutId_1;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            url_1 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 3;
            arrayBuffer = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 4;
            arrayBuffer_1 = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 5;
            extractedData = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 6;
            ex_1 = msg.fields[0];
            break;
        }
        case 7: {
            matchResult = 7;
            extractedData_1 = msg.fields[0];
            break;
        }
        case 8: {
            matchResult = 8;
            imageData = msg.fields[0];
            break;
        }
        case 9: {
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 1: {
                        matchResult = 11;
                        reportData = msg.fields[0].fields[0].fields[1];
                        svm = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 0: {
                        matchResult = 12;
                        status = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    case 3: {
                        matchResult = 16;
                        isReady = msg.fields[0].fields[0].fields[1];
                        viewportId = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    default:
                        matchResult = 10;
                }
            }
            else {
                matchResult = 9;
                msg_13 = msg.fields[0].fields[0];
            }
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 1) {
                switch (msg.fields[0].fields[0].tag) {
                    case 1: {
                        matchResult = 15;
                        break;
                    }
                    case 2: {
                        matchResult = 16;
                        isReady = msg.fields[0].fields[0].fields[1];
                        viewportId = msg.fields[0].fields[0].fields[0];
                        break;
                    }
                    default: {
                        matchResult = 14;
                        reportData_1 = msg.fields[0].fields[0].fields[1];
                        svm_1 = msg.fields[0].fields[0].fields[0];
                    }
                }
            }
            else {
                matchResult = 13;
                msg_22 = msg.fields[0].fields[0];
            }
            break;
        }
        case 11: {
            matchResult = 17;
            break;
        }
        case 12: {
            matchResult = 18;
            timeoutId_1 = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 19;
            break;
        }
        default: {
            matchResult = 0;
            ex = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some(ex));
            return [model, Toast_errorToast((arg = ex.message, toText(printf("Operation failed, please contact ViTAA Support. Error: %s"))(arg))), Cmd_none()];
        }
        case 1:
            return [model, Cmd_OfPromise_either((fileName) => getSignedUrlPromise(model.S3Context, fileName), model.VisualizationDataFile, (url) => (new LocalMsg(2, [url])), (Item) => (new LocalMsg(0, [Item]))), Cmd_none()];
        case 2:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, new LoadingStatus_5(1, []), model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_OfAsyncWith_either((x) => {
                Cmd_OfAsync_start(x);
            }, fetchDataAsArrayBuffer, url_1, (Item_1) => (new LocalMsg(3, [Item_1])), (Item_2) => (new LocalMsg(0, [Item_2]))), Cmd_none()];
        case 3:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, new LoadingStatus_5(2, []), model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), singleton((dispatch) => {
                dispatch(new LocalMsg(4, [arrayBuffer]));
            }), Cmd_none()];
        case 4:
            return [model, Cmd_OfPromise_either(extractData, arrayBuffer_1, (Item_4) => (new LocalMsg(5, [Item_4])), (Item_5) => (new LocalMsg(6, [Item_5]))), Cmd_none()];
        case 5:
            return [model, singleton((dispatch_1) => {
                dispatch_1(new LocalMsg(7, [extractedData]));
            }), Cmd_none()];
        case 6:
            return [model, Cmd_batch(ofArray([Toast_errorToast(ex_1.message), singleton((dispatch_2) => {
                dispatch_2(new LocalMsg(0, [ex_1]));
            })])), Cmd_none()];
        case 7:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, new LoadingStatus_5(3, []), model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_batch((list_2 = map((msg_11) => singleton((dispatch_3) => {
                dispatch_3(msg_11);
            }), toList(delay(() => append(singleton_2(new LocalMsg(8, [extractedData_1.ImageData])), delay(() => ((model.VisualizationSubcomponentModel.tag === 1) ? append(singleton_2(new LocalMsg(10, [wrapInboundMsg(new InboundMsg_1(0, [extractedData_1.MeshData]))])), delay(() => singleton_2(new LocalMsg(10, [wrapInboundMsg(new InboundMsg_1(1, [extractedData_1.Checksum]))])))) : append(singleton_2(new LocalMsg(9, [wrapInboundMsg(new InboundMsg(1, [extractedData_1.MeshData]))])), delay(() => singleton_2(new LocalMsg(9, [wrapInboundMsg(new InboundMsg(0, [extractedData_1]))])))))))))), append_1(singleton(Cmd_ofEffect((dispatch_4) => {
                dispatch_4(new LocalMsg(12, [Shared_delayedMsg(new LocalMsg(11, []), 30000, dispatch_4)]));
            })), list_2))), Cmd_none()];
        case 8:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, imageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_none(), Cmd_none()];
        case 9: {
            const matchValue_1 = model.VisualizationSubcomponentModel;
            if (matchValue_1.tag === 1) {
                toConsole(printf("Unexpected StentPlanning component message when VisualizationTemp component is loaded. Ignoring."));
                return [model, Cmd_none(), Cmd_none()];
            }
            else {
                const patternInput = update(token, msg_13, matchValue_1.fields[0]);
                return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, new VisualizationSubcomponentModel_2(0, [patternInput[0]]), model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_map((Item_7) => (new LocalMsg(9, [Item_7])), patternInput[1]), Cmd_none()];
            }
        }
        case 10:
            return [model, singleton((dispatch_5) => {
                dispatch_5(new LocalMsg(13, []));
            }), singleton((dispatch_6) => {
                dispatch_6(new OutboundMsg(0, []));
            })];
        case 11:
            return [model, Cmd_none(), singleton((dispatch_7) => {
                dispatch_7(new OutboundMsg(1, [svm, reportData]));
            })];
        case 12:
            return [model, Cmd_none(), singleton((dispatch_8) => {
                dispatch_8(new OutboundMsg(3, [status]));
            })];
        case 13: {
            const matchValue_2 = model.VisualizationSubcomponentModel;
            if (matchValue_2.tag === 0) {
                toConsole(printf("Unexpected VisualizationTemp component message when StentPlanning component is loaded. Ignoring."));
                return [model, Cmd_none(), Cmd_none()];
            }
            else {
                const patternInput_1 = update_1(token, msg_22, matchValue_2.fields[0]);
                return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, new VisualizationSubcomponentModel_2(1, [patternInput_1[0]]), model.ViewportReadyStatusMap, model.MaybeTimeoutId), Cmd_map((Item_8) => (new LocalMsg(10, [Item_8])), patternInput_1[1]), Cmd_none()];
            }
        }
        case 14:
            return [model, Cmd_none(), singleton((dispatch_9) => {
                dispatch_9(new OutboundMsg(2, [svm_1, reportData_1]));
            })];
        case 15:
            return [model, singleton((dispatch_10) => {
                dispatch_10(new LocalMsg(13, []));
            }), singleton((dispatch_11) => {
                dispatch_11(new OutboundMsg(0, []));
            })];
        case 16: {
            const visualizationReadyMap = add(viewportId, isReady, model.ViewportReadyStatusMap);
            return [equals(model.LoadingStatus, new LoadingStatus_5(4, [])) ? model : ((!FSharpMap__get_IsEmpty(visualizationReadyMap) && forAll((_arg, isReady_1) => isReady_1, visualizationReadyMap)) ? (new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, new LoadingStatus_5(4, []), model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, empty({
                Compare: comparePrimitives,
            }), model.MaybeTimeoutId)) : (new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, visualizationReadyMap, model.MaybeTimeoutId))), Cmd_none(), Cmd_none()];
        }
        case 17:
            if (!equals(model.LoadingStatus, new LoadingStatus_5(4, []))) {
                return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, new LoadingStatus_5(4, []), model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, empty({
                    Compare: comparePrimitives,
                }), model.MaybeTimeoutId), Toast_warningToastWithTimeout(0, "Rendering may have not completed properly. Please refresh the page if visualization issues are encountered."), Cmd_none()];
            }
            else {
                return [model, Cmd_none(), Cmd_none()];
            }
        case 18:
            return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, timeoutId_1), Cmd_none(), Cmd_none()];
        default: {
            const matchValue_3 = model.MaybeTimeoutId;
            if (matchValue_3 == null) {
                return [model, Cmd_none(), Cmd_none()];
            }
            else {
                const timeoutId_2 = matchValue_3;
                window.clearTimeout(timeoutId_2);
                return [new ModelVisualization(model.MaybeCurrentUser, model.PatientInstitutionDesignation, model.VisualizationDataFile, model.LoadingStatus, model.ImageData, model.S3Context, model.SelectedStudy, model.SelectedPatientId, model.CurrentStudyAnalysisPipelineVersion, model.MaybePrevStudyAnalysisPipelineVersion, model.VisualizationSubcomponentModel, model.ViewportReadyStatusMap, undefined), Cmd_none(), Cmd_none()];
            }
        }
    }
}

export function updateVisualization(token, msg, model) {
    return update_2(updateLocal, updateInbound, token, msg, model);
}

